module.exports = __webpack_public_path__ + "static/media/KPMG-Logo.2eb178d7.jpg";